export default __webpack_public_path__ + "static/media/nick.0391377f.jpg";